import { lazy } from "react";
import { ChevronUp, CloudUpload, Flag, Lock, Printer, ScanLine, SkipForward, Smartphone, Usb } from "lucide-react";
import { Route, Routes } from "react-router";
import { defineWebModule } from "../../web/module";
import { showSessionsSection } from "./web/Extras";
import "./web/sessions.css";

// Pages load when opened, so the app starts fast on a phone with weak signal.
const AnimalSessions = lazy(() => import("./web/Extras").then((m) => ({ default: m.AnimalSessions })));
const PendingSyncCard = lazy(() => import("./web/Extras").then((m) => ({ default: m.PendingSyncCard })));
const SessionsHome = lazy(() => import("./web/Home").then((m) => ({ default: m.SessionsHome })));
const Runner = lazy(() => import("./web/Runner").then((m) => ({ default: m.Runner })));
const StartSession = lazy(() => import("./web/Start").then((m) => ({ default: m.StartSession })));
const ChuteSheet = lazy(() => import("./web/Summary").then((m) => ({ default: m.ChuteSheet })));
const TemplateEditor = lazy(() => import("./web/Templates").then((m) => ({ default: m.TemplateEditor })));
const DevicesPage = lazy(() => import("./web/Devices").then((m) => ({ default: m.DevicesPage })));
const SessionJob = lazy(() => import("./web/SessionJob").then((m) => ({ default: m.SessionJob })));

/** Work → Field sessions, with its own pages below /work/sessions. */
function SessionsWorkspace() {
  return (
    <Routes>
      <Route index element={<SessionsHome />} />
      <Route path="new" element={<StartSession />} />
      <Route path="templates/:templateId" element={<TemplateEditor />} />
      <Route path=":id/run" element={<Runner />} />
      <Route path=":id/sheet" element={<ChuteSheet />} />
      <Route path="*" element={<SessionsHome />} />
    </Routes>
  );
}

export default defineWebModule({
  id: "sessions",
  icons: { scan: ScanLine, usb: Usb, printer: Printer, lock: Lock, flag: Flag, skip: SkipForward, phone: Smartphone, cloudUp: CloudUpload, up: ChevronUp },
  workspaces: { sessions: SessionsWorkspace },
  ranchSections: { devices: DevicesPage },
  jobs: { "sessions.chute": SessionJob, "sessions.pen": SessionJob },
  animalSections: [{ id: "sessions", label: "Field sessions", order: 85, show: showSessionsSection, Component: AnimalSessions }],
  todayCards: [PendingSyncCard],
});
